import { useDispatch as useReduxDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import axios from 'axios';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import Reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loginreducer']  // Only persist this part of state
}

const persistedReducer = persistReducer(persistConfig, Reducers)
const store = configureStore({
  reducer: {
    reducers: persistedReducer,
  },
  devTools: true,
  middleware: [thunk]
});
export const useDispatch = () => useReduxDispatch();
const persister = persistStore(store);
const { dispatch } = store;
axios.interceptors.request.use(function (config) {
  dispatch({ type: "SHOW_LOADING_SPINNER", payload: true });
  return config;
}, function (error) {
  alert(error)
  dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
  return response;
}, function (error) {
  dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
  return Promise.reject(error);
})

export { store, persister };